module.exports = __webpack_public_path__ + "media/images/icon/icons8-Toggle Off-27c65ee6c2c21b360e18cd551b2f9c98.png";